const initSwiperForTestimonials = () => {
  const sections = document.querySelectorAll(".testimonials-section__list");

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const swiperEl = section.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });
  });
};

function initSwiperForLatestArticlesSection() {
  const sections = document.querySelectorAll(".latest-articles__list");

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const swiperEl = section.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1.3,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });
  });
}

function initSwiperForFeaturedCategoriesSection() {
  const sections = document.querySelectorAll(
    ".featured-categories-section-list"
  );

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const swiperEl = section.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  });
}

function initSwiperForFeaturedProductsSection() {
  const sections = document.querySelectorAll(".featured-products-section-list");

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const numberOfSlides = section.dataset.productsShow;
    const swiperEl = section.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1.3,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: numberOfSlides,
          spaceBetween: 48,
        },
      },
    });
  });
}

function playVideoCards() {
  const cards = document.querySelectorAll(".testimonials-section__card-video");

  if (!cards) {
    return;
  }

  cards.forEach((card) => {
    const playButton = card.querySelector(".video_play_button");
    const playButtonImage = card.querySelector(".video_play_button svg");
    const video = card.querySelector("video");
    const spinner = card.querySelector(".video_spinner");

    playButton.addEventListener("click", () => {
      video.onwaiting = function () {
        spinner.classList.remove("hide");
      };

      video.onplaying = function () {
        spinner.classList.add("hide");
      };

      if (video.classList.contains("lazy")) {
        const videoSources = Array.from(video.querySelectorAll("source"));

        if (!videoSources.length) {
          return;
        }

        videoSources.forEach((source) => {
          source.src = source.dataset.src;
        });

        video.load();
        video.classList.remove("lazy");
      }

      if (video.paused) {
        pauseAllVideos(cards);
        playButtonImage.classList.add("hide");
        video.play();
      } else {
        playButtonImage.classList.remove("hide");
        video.pause();
      }
    });
  });

  function pauseAllVideos(video_cards) {
    video_cards.forEach((video) => {
      const videoPlayer = video.querySelector("video");
      const playButtonImage = video.querySelector(".video_play_button svg");

      playButtonImage.classList.remove("hide");
      videoPlayer.pause();
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initSwiperForTestimonials();
  initSwiperForLatestArticlesSection();
  initSwiperForFeaturedCategoriesSection();
  initSwiperForFeaturedProductsSection();
  playVideoCards();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    initSwiperForTestimonials();
    initSwiperForLatestArticlesSection();
    initSwiperForFeaturedCategoriesSection();
    initSwiperForFeaturedProductsSection();
    playVideoCards();
  });
}

